import { Controller } from "@hotwired/stimulus";
import throttle from "../../utils/throttle";

export default class extends Controller {
    connect() {
        this.onScroll = this.checkVisibility.bind(this);
        this.footer = document.querySelector(".js-footer");

        this.onResize = throttle(this.applyMarginToFooter.bind(this), 300);
        window.addEventListener('resize', this.onResize);

        window.addEventListener('scroll', this.onScroll);
        this.checkVisibility();
    }
    disconnect() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
    }
    applyMarginToFooter() {
        this.footer.style.marginBottom = (this.element.getBoundingClientRect().height - 20)+"px";
    }
    checkVisibility() {
        let offset = this.element.getBoundingClientRect().height + 200;
        let scrollTop = window.scrollY || document.documentElement.scrollTop;
        let viewportH = window.innerHeight || document.documentElement.clientHeight;
        let docH = Math.max(
            document.body.scrollHeight,
            document.documentElement.scrollHeight
        );
        let nearBottom = scrollTop + viewportH >= docH - offset;
        if(nearBottom) {
            this.element.setAttribute("data-show","true");
        } else {
            this.element.removeAttribute("data-show");
        }
    }
}